import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatTableModule as MatTableModule} from '@angular/material/table';
import {MatMenuModule as MatMenuModule} from '@angular/material/menu';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {DragDropModule, CdkDropList, CdkDrag} from '@angular/cdk/drag-drop';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule as MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule as MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule as MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule as MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule as MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatSidenavModule} from '@angular/material/sidenav';

import {MatExpansionModule} from '@angular/material/expansion';

import {MatTooltipModule} from '@angular/material/tooltip';



import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'
import {MatDialogModule as MatDialogModule} from '@angular/material/dialog';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports:[
    MatNativeDateModule,
    MatDatepickerModule,  
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatMenuModule,
    MatButtonToggleModule,
    DragDropModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatPaginatorModule,
    MatSortModule,
    MatSidenavModule,
    MatDialogModule,
    MatButtonModule,
    MatExpansionModule,
    MatTooltipModule
  ]
})
export class MaterialModule { }
